import React from 'react';
import {
  Container,
  ContainerAi,
  // LabelsHolder,
  // LabelHolder,
  // Label,
  // HiddenLabel,
  // LogoutIcon,
  // Separator,
} from './style';
// import NotificationIcon from './components/notification-icon';
// import LogoutConfirmationModal from './components/logout-confirmation-modal';
// import { useLoggedUser } from 'state/user';
// import { removeToken, removeAdminToken } from 'services/storage';
// import { clearStore } from 'services/apollo-client';
// import { useHistory } from 'react-router';
// import { useSpring } from 'react-spring';
// import { useCanvasClipboardOperations } from 'state/canvas-clipboard';
import { gql, useMutation, useQuery } from '@apollo/client';
// import styled from 'styled-components';
// import { Rating } from '@mui/material';
import { surfaceNodeQuery } from 'graphql/surface-node/queries/surface-node';

// import { ThemeProvider, createTheme } from '@mui/material/styles';

import LinkArrow from 'components/canvas/components/link-arrow';
import CollaboratingUsersCursors, {
  useCollaboratingCursorListeners,
} from 'routes/surface/components/collaborating-users-cursors';
import SurfaceSubscriptionListeners from 'routes/surface/components/surface-subscriptions-listeners';
import useNodeSearchParams from 'routes/surface/hooks/use-node-search-params';
import { useSurfaceNodeModalsOperations } from 'routes/surface/hooks/use-surface-node-modals-context';
import { useHistory, useParams } from 'react-router-dom';
import { configuration } from 'components/pspdf';
import { Line } from 'react-konva';
// import { Container } from '@material-ui/core';
// import Stack from '@mui/material/Stack';
import {
  // Container,
  Stack,
  Grid,
  List,
  ListItem,
  Rating,
  Typography,
  Button,
  TextField,
  ListItemText,
  Toolbar,
} from '@mui/material';
// import { Fab, ListItemText, Toolbar } from '@material-ui/core';
import styled from 'styled-components';
import useFetchLoggedUser from 'hooks/use-fetch-logged-user';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from 'styled-components';

import client from 'services/apollo-client';
import logo from 'styles/icons/immoOx-Text.png';
import logo1 from 'styles/icons/LogoImmo.png';
import { templates } from 'routes';
import Box from '@mui/material/Box';
// import { querstionairesQuery } from '../../../../listDetail';
import { updateSurfaceMutation } from 'graphql/surface-node/mutations/update-surface';
import { pick } from 'lodash';
import { withPortratitGuard } from 'routes/share/template-page/guard';
import { media } from 'styles/settings';
import { templateList } from 'routes/templates/tempates';
import { surfaceHierarchyQuery } from 'graphql/surface/queries/surface-hierarchy';
import aiQuery from 'graphql/ai/queries/ai-question';

const StyledA = styled.a`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: left;
  /* margin-bottom: 20px; */
  font-size: 20px;
  margin-right: 10px;
  margin-left: 10px;
  /* position: absolute; */
`;

export const querstionairesQuery = gql`
  query questionnaires($id: ID!) {
    questionnaireForSurface(id: $id) {
      data {
        id
        surface {
          id
          name
          description
          rating
          ratingComment
        }
        questions {
          id
          # hint
          question
          type
          order
          hint
          required
        }
        templateId
      }
    }
  }
`;

const Label = styled.div`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: left;
  margin-bottom: 2px;
  font-size: 14px;
  /* position: absolute; */
`;

export default function QuestionaireUI({ surface }) {
  const history = useHistory();
  // const modal = React.useRef<any>(null);
  // const hiddenLabelRef = React.createRef();

  const { data: hierachy, loading } = useQuery<any>(surfaceHierarchyQuery, {
    client,
    fetchPolicy: 'cache-and-network',
    variables: { input: { surface } },
  });

  const notFound =
    loading === false && hierachy?.surfaceHierarchy?.success === false;

  const surfaceHierarchy = hierachy?.surfaceHierarchy?.data ?? [];
  const parentId = surfaceHierarchy[surfaceHierarchy.length - 2]?.id;
  console.log('data Parent', surfaceHierarchy, parentId);

  const { data } = useQuery(querstionairesQuery, {
    variables: { id: parentId },
    // fetchPolicy: 'cache-only',
  });

  const { data: d2 } = useQuery(surfaceNodeQuery, {
    variables: { id: surface },
    // fetchPolicy: 'cache-only',
  });

  const questionsData = data?.questionnaireForSurface?.data ?? null;
  const surfaceData = d2?.surfaceNode?.data;

  console.log('data', questionsData?.surface);
  console.log('data2', surfaceData);

  // const labelHolderWidthAnimation = useSpring({
  //   from: { width: 0 },
  //   to: { width: fullNameLabelWidth },
  //   config: { duration: 500 },
  // });

  // const opacityAnimation = useSpring({
  //   from: { opacity: 0 },
  //   to: { opacity: fullNameLabelWidth > 0 ? 1 : 0 },
  //   delay: 450,
  // });

  // function onConfirm() {
  //   removeToken();
  //   removeAdminToken();
  //   clearStore();
  //   clearClipboard();
  //   history.push('/login'); // redirect user to login page
  // }

  // function showLogOutModal() {
  //   modal.current.show();
  // }

  // React.useEffect(() => {
  //   const hiddenLabelElement = hiddenLabelRef.current as HTMLElement;
  //   setFullNameLabelWidth(hiddenLabelElement.getBoundingClientRect().width);
  // }, [hiddenLabelRef, fullName]);

  const [isActive, setActive] = React.useState(false);

  const [rating, setRating] = React.useState(0);
  const [ratingComment, setRatingComment] = React.useState('');

  const [updateSurface] = useMutation(updateSurfaceMutation);

  function surfaceOperation(data) {
    const keys = ['name', 'id', 'rating', 'description', 'ratingComment'];

    const input = pick(data, keys);

    // if (input.id) {
    //   return updateSurface({ variables: { input } });
    // }

    return updateSurface({ variables: { input } });
  }

  const saveClicked = async () => {
    console.log('CLICKED');
    setActive(false);
    await surfaceOperation({
      id: surface,
      rating: `${rating}`,
      ratingComment: ratingComment,
    });
  };

  if (surfaceData?.rating === undefined) {
    return null;
  }

  const theme = createTheme({
    // palette: {
    //   primary: {
    //     // main: red[500],
    //   },
    // },
  });

  var templ = undefined;
  if (questionsData?.templateId) {
    templ = templateList.find((entry) => entry.id == questionsData?.templateId);
  }

  // const theme = createTheme({
  //   // palette: {
  //   //   primary: {
  //   //     // main: red[500],
  //   //   },
  //   // },
  // });
  // console.log('Rating?  ', templ, templ.id, templ.id == 'io');
  const hasRating = templ?.hasRating === true;
  if (templ?.id == 'id-immoox-5') {
    console.log('AI TRUE?  ', templ, questionsData);
    return <AIHelper templ={templ} id={surface}></AIHelper>;
  }

  if (!hasRating) {
    return null;
  }

  return (
    <>
      {/* <LogoutConfirmationModal ref={modal} width="30%" onConfirm={onConfirm} /> */}
      <ThemeProvider theme={{ ...theme }}>
        <Container onClick={() => setActive(true)}>
          {!isActive && (
            <Rating
              readOnly={!isActive}
              name="read-only"
              defaultValue={surfaceData.rating || 0}
              // size={'large'}
              onChange={(_, v) => {
                console.log('RATING CHANGES', v);
                // setRating(v);
              }}
            />
          )}
          {isActive && (
            <Stack spacing={2}>
              {/* <Label>Bewertung</Label> */}
              <Rating
                name="read-only"
                defaultValue={surfaceData.rating}
                size={'large'}
                onChange={(_, v) => {
                  console.log('RATING CHANGES', v);
                  setRating(v);
                }}
              />
              <Label>Kommentar</Label>

              <TextField
                inputProps={{ color: 'yellow' }}
                sx={{ color: 'yellow' }}
                variant="standard"
                defaultValue={surfaceData.ratingComment}
                onChange={(c, v) => {
                  console.log('RATING COMMENT CHANGES', v, c.target.value);
                  setRatingComment(c.target.value);
                }}></TextField>
              <Button
                sx={{ width: 100 }}
                fullWidth={false}
                onClick={saveClicked}>
                Speichern
              </Button>
              {/* <Button
                sx={{ width: 100 }}
                fullWidth={false}
                onClick={setActive(false)}>
                Abbrechen
              </Button> */}
            </Stack>
          )}

          {/* {isActive && surfaceData.ratingComment} */}
          {/* <NotificationIcon style={opacityAnimation} />
        <Separator />
        <LabelsHolder>
          <HiddenLabel ref={hiddenLabelRef}>{fullName}</HiddenLabel>
          <LabelHolder style={labelHolderWidthAnimation}>
            <Label style={opacityAnimation}>{fullName}</Label>
          </LabelHolder>
        </LabelsHolder>
        <LogoutIcon onClick={showLogOutModal} /> */}
        </Container>
      </ThemeProvider>
    </>
  );
}

const AIHelper = ({ templ, id }) => {
  const theme = createTheme({
    // palette: {
    //   primary: {
    //     // main: red[500],
    //   },
    // },
  });

  const [isActive, setActive] = React.useState(true);

  const call = async () => {
    console.log('clicked', templ);
    setActive(false);

    try {
      await queryAi(id, templ);
      window.location.reload();
    } catch (error) {
      alert(error);
    }
    setActive(true);
    // setTimeout(() => {
    //   setActive(true);
    // }, 2000);
  };

  const queryAi = async (id, templ) => {
    console.log('addasd', id, templ);
    const r = await aiQuery({
      input: { node: id, type: templ.id },
    });
    console.log(' AAA ', r);
    return r.data;
  };

  return (
    <ThemeProvider theme={{ ...theme }}>
      <ContainerAi onClick={isActive ? call : () => {}}>
        <AIIcon color={isActive ? 'black' : 'red'} />
      </ContainerAi>
    </ThemeProvider>
  );
};

const AIIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 50 50"
    {...props}>
    <path
      fill="currentColor"
      d="M21.361 2c-5.451 0-8.954 2.518-10.049 5.22C7.02 8.135 4 12.83 4 17.999c0 2.127.617 4.257 1.686 6.621C4.813 25.687 4 27.026 4 29c0 2.587 1.694 5.08 4.713 6.469-.948 2.206-.745 4.333.385 5.847 1.173 1.573 3.144 2.391 5.261 2.553.642 1.686 1.798 2.857 3.079 3.414 1.458.635 2.95.717 3.923.717a4.593 4.593 0 0 0 3.641-1.79A4.63 4.63 0 0 0 28.631 48h.002c.92.007 2.406-.077 3.877-.71 1.269-.548 2.423-1.699 3.084-3.34 1.598-.052 3.252-.29 4.654-1.079C41.823 41.984 43 40.304 43 38c0-.9-.325-1.732-.709-2.568 1.284-.639 2.296-1.456 2.85-2.465C45.839 31.695 46 30.3 46 29c0-1.993-.941-3.192-1.855-4.172 1.084-2.364 1.89-4.65 1.855-6.846-.093-5.834-4.025-9.93-8.29-10.777C36.76 4.707 34.06 2 28.64 2c-1.364 0-2.69.35-3.526 1.428-.04.053-.074.112-.113.168-.039-.056-.072-.115-.113-.168C24.05 2.35 22.725 2 21.36 2zm0 2c1.08 0 1.573.172 1.946.652.372.48.693 1.56.693 3.534v5.646a1 1 0 0 0 0 .326V18h-3v-5h-4.188c-.417-1.157-1.519-2-2.812-2-1.645 0-3 1.355-3 3s1.355 3 3 3c1.293 0 2.395-.843 2.813-2H19v5h5v8h-7v6.188c-1.157.417-2 1.519-2 2.812 0 1.645 1.355 3 3 3s3-1.355 3-3c0-1.293-.843-2.395-2-2.813V30h5v6.832a1 1 0 0 0 0 .326v6.174C24 44.969 22.94 46 21.361 46c-.842 0-2.082-.097-3.125-.55-1.043-.455-1.889-1.166-2.265-2.69l-.188-.76H15c-1.834 0-3.466-.763-4.299-1.879-.832-1.116-1.053-2.574.158-4.61l.633-1.064-1.174-.394C7.267 33.027 6 30.976 6 29c0-1.72.638-2.587 1.541-3.574L7.93 25h3.258c.417 1.157 1.519 2 2.812 2 1.645 0 3-1.355 3-3s-1.355-3-3-3c-1.293 0-2.395.843-2.813 2H7.133C6.375 21.153 6 19.561 6 17.998c0-4.59 2.875-8.607 6.121-9.006l.66-.08.18-.639C13.409 6.7 16.239 4 21.36 4zm7.278 0c5.122 0 6.876 2.433 7.4 4.273l.182.64.658.08c3.372.413 7.038 3.837 7.121 9.023.03 1.84-.723 4.084-1.902 6.552l-.303.635.492.498C43.33 26.76 44 27.321 44 29c0 1.127-.154 2.166-.613 3.004-.293.534-.736 1.005-1.387 1.412V29h-9v-3.188c1.157-.417 2-1.519 2-2.812 0-1.645-1.355-3-3-3s-3 1.355-3 3c0 1.293.843 2.395 2 2.813V31h9v3.857a1 1 0 0 0 .129.66 1 1 0 0 0 .002.003c.518 1.057.869 1.955.869 2.48 0 1.696-.647 2.516-1.734 3.129-1.088.613-2.69.871-4.266.871h-.783l-.188.76c-.374 1.513-1.246 2.235-2.31 2.693-1.064.458-2.309.552-3.073.547C27.06 45.989 26 44.969 26 43.332V38h4.188c.417 1.157 1.519 2 2.812 2 1.645 0 3-1.355 3-3s-1.355-3-3-3c-1.293 0-2.395.843-2.813 2H26v-6.832a1 1 0 0 0 0-.326v-9.674a1 1 0 0 0 0-.326V15h8.188c.417 1.157 1.519 2 2.812 2 1.645 0 3-1.355 3-3s-1.355-3-3-3c-1.293 0-2.395.843-2.813 2H26V8.186c0-1.975.32-3.053.693-3.534.373-.48.867-.652 1.946-.652zM14 13c.544 0 .958.409.988.943a1 1 0 0 0 0 .116A.978.978 0 0 1 14 15c-.564 0-1-.436-1-1 0-.564.436-1 1-1zm23 0c.564 0 1 .436 1 1 0 .564-.436 1-1 1a.978.978 0 0 1-.988-.943 1 1 0 0 0 0-.116A.978.978 0 0 1 37 13zm-5 9c.564 0 1 .436 1 1a.978.978 0 0 1-.943.988 1 1 0 0 0-.073-.002 1 1 0 0 0-.043.002A.978.978 0 0 1 31 23c0-.564.436-1 1-1zm-18 1c.564 0 1 .436 1 1 0 .564-.436 1-1 1a.978.978 0 0 1-.988-.943 1 1 0 0 0 0-.116A.978.978 0 0 1 14 23zm19 13c.564 0 1 .436 1 1 0 .564-.436 1-1 1a.978.978 0 0 1-.988-.943 1 1 0 0 0 0-.116A.978.978 0 0 1 33 36zm-15.057.012a1 1 0 0 0 .116 0c.533.03.941.445.941.988 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.544.409-.958.943-.988z"
    />
  </svg>
);
